export const MiniQ24GConfigAlertsValues = {
    nivel_llenado_a: 90,
    nivel_llenado_d: 80,
    difllen: 40,
    difvac: 60,
    sacc: 1,
    t_volcado: 240,
    t_mov_permanente: 240,
    angulo_a: 180,
    angulo_d: 90,
    alta_temp_a: 70,
    alta_temp_d: 70,
    baja_temp_a: 5,
    baja_temp_d: 10,
    incendio: 1,
    bat: 10,
};
export const MiniQ24GConfigAlertsHas = {
    nivel_llenado_a: true,
    nivel_llenado_d: true,
    difllen: true,
    difvac: true,
    sacc: true,
    t_volcado: true,
    t_mov_permanente: true,
    angulo_a: true,
    angulo_d: true,
    alta_temp_a: true,
    alta_temp_d: true,
    baja_temp_a: true,
    baja_temp_d: true,
    incendio: true,
    bat: true,
};
